<template>
  <section
    ref="searchSection"
    v-on-click-outside="hideResults"
    class="relative font-semibold text-black w-full"
  >
    <div class="relative w-full">
      <span class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <FontAwesomeIcon
          :icon="faSearch"
          class="text-gray-400 text-lg"
        />
      </span>

      <input
        v-model="searchParams.search"
        type="text"
        class="w-full border border-gray-300 text-gray-700 py-2.5 !pl-9 pr-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-colors"
        placeholder="Type to search frameworks"
        autocomplete="off"
        @focus="handleFocus"
      >

      <span class="absolute inset-y-0 right-0 mr-3 flex items-center pointer-events-none">
        <FontAwesomeIcon
          :icon="faChevronDown"
          class="text-gray-500 text-sm"
        />
      </span>
    </div>

    <div
      v-if="showSearchResults && searchResults.length > 0"
      class="relative z-50 top-full mt-1 bg-white flex flex-col divide-y divide-gray-100 rounded-md border border-gray-200 shadow-lg w-full max-h-64 overflow-y-auto"
    >
      <div
        v-for="result in searchResults"
        :key="result.id"
        class="px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm font-normal shrink-0"
        @click="selectResult(result)"
      >
        {{ result.name }}
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, nextTick } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import { faSearch, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

defineProps({
  searchResults: { type: Array, default: () => [] },
});

const emit = defineEmits(['select']);
const searchParams = defineModel('searchParams');
const showSearchResults = defineModel('showSearchResults');

const searchSection = ref(null);

const handleFocus = async () => {
  showSearchResults.value = true;
  await nextTick();

  if (searchSection.value) {
    const modal = searchSection.value.closest('.modal-body');
    const dropdown = searchSection.value.querySelector('.z-50');
    if (!modal || !dropdown) return;

    // get bottom position of the dropdown menu
    const dropdownRect = dropdown.getBoundingClientRect();
    const modalRect = modal.getBoundingClientRect();

    // See if the bottom of that dropdown (plus buffer) is past the modal bottom
    const buffer = 40;
    const distancePastBottom = (dropdownRect.bottom + buffer) - modalRect.bottom;

    if (distancePastBottom > 0) {
      modal.scrollBy({
        top: distancePastBottom,
        behavior: 'smooth',
      });
    }
  }
};

const hideResults = () => showSearchResults.value = false;

const selectResult = (result) => {
  emit('select', result.id);
  showSearchResults.value = false;
};
</script>
